
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1741",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2643",
    d: "M14.915 13.669l.2 3.451a.37.37 0 00.369.348h1.278a.374.374 0 00.369-.348l.2-3.451a.37.37 0 00-.369-.392h-1.677a.37.37 0 00-.37.392zm2.5 5.525a1.294 1.294 0 00-1.29-1.294 1.294 1.294 0 00-1.294 1.294 1.294 1.294 0 001.294 1.295 1.294 1.294 0 001.294-1.295zM17.402 8.1a1.48 1.48 0 00-2.562 0L7.45 20.92a1.48 1.48 0 001.281 2.219h14.788A1.48 1.48 0 0024.8 20.92zM8.889 21.382l7.076-12.264a.185.185 0 01.32 0l7.076 12.264a.185.185 0 01-.16.277H9.05a.185.185 0 01-.161-.277z",
    fill: "currentColor"
  })));
}

export { SvgWarning as default };
//# sourceMappingURL=warning.svg.js.map
